import React, { Component } from 'react'
import Linkify from 'react-linkify'
import moment from 'moment'

require('./message.scss')
require('./genericAction.scss')

export default class GenericActionView extends Component {
  render() {
    return (
      <div key={this.props.id} className="single-message single-action-message">
        <span className="single-message-timestamp">[{moment(this.props.timestamp).format('HH:mm:ss')}]</span>
        <Linkify properties={{ target: '_blank' }}>
          <span style={{ fontWeight: 'medium', color: this.props.color }}>{this.props.text}</span>
        </Linkify>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/messages/pro/GenericAction.jsx